import {Link} from 'gatsby';
import React, {useEffect, useRef, useState} from 'react';
import '../Styles/subscribeBanner.module.scss';
import {getMonthlySubscriptionPrice} from './Utils';
// import cookie from 'react-cookies';

const SubscribeBanner = () => {
  const priceRef = useRef(null);
  const currencyRef = useRef(null);
  const [showPrices, setShowPrices] = useState(false);

  // const countryCode = cookie.load('geotargetly_country_code');
  useEffect(() => {
    const monthlyPrice = getMonthlySubscriptionPrice();
    if (monthlyPrice) {
      if (priceRef?.current && currencyRef?.current) {
        priceRef.current.textContent = monthlyPrice.cur_symbol;
        currencyRef.current.textContent = monthlyPrice.price;
      }
    }
    setTimeout(() => {
      setShowPrices(true);
    }, 300);
  }, []);

  return (
    <div className='subscribe-banner-container'>
      <div className='subscribe-banner'>
        <div className='subscribe-banner-left-section'>
          <h2>Actionable skills,</h2>
          <h3>Infinite possibilities.</h3>
          <p>Unique lessons curated by in-house experts!</p>
        </div>
        <div className='subscribe-banner-right-section'>
          {/* { showPrices && countryCode && countryCode=='us' ? <section>
            <div className='price-save'>
              <h3>What you&apos;ll get:</h3>
            </div>
            <ul>
              <li>Choose from <span>80+ courses</span> to learn.</li>
              <li>Get the selected course for life</li>
              <li>Courses range in length up to <span>32 hours.</span></li>
              <li>Schedule or <span>watch when you want.</span></li>
              <li>Industry leading <span>customer support.</span></li>
              <li>Free <span>Course materials</span></li>
            </ul>

            <div className='subscribe-banner-price-section'>
              <div className={'subscription-price USlifetime'}>
                <div className='previousPriceSec'>
                  <p >$&nbsp;</p>
                  <span className='price-number'>250</span>

                </div>
                <div className='newPriceSec'>
                  <p >$&nbsp;</p>
                  <span className='price-number'>89</span>
                  <p className='subText'>&nbsp;(One Time)</p>
                </div>

              </div>
            </div>
            <Link to='/courses/' className='subscrice-banner-cta'>
              Enroll Now
            </Link>
          </section>:  */}
          <section>
            <div className='price-save'>
              <h3>What you&apos;ll get:</h3>
            </div>
            <ul>
              <li>Choose from <span>80+ courses</span> to learn.</li>
              <li>Courses range in length up to <span>32 hours.</span></li>
              <li>Schedule or <span>watch when you want.</span></li>
              <li>Industry leading <span>customer support.</span></li>
              <li><span>Course materials</span> and <span>
                eCerts</span> available for purchase</li>
            </ul>

            <div className='subscribe-banner-price-section'>
              <div className={'subscription-price monthly'}>
                <p ref={priceRef}></p>
                <span ref={currencyRef}>&nbsp;</span>
                <p className='subText'>&nbsp;/month</p>
              </div>
              <div className="tryFree">
                <p>Try for FREE</p>
              </div>
            </div>

            {/* <p className='subscription-desc'>
            28 days will be added to your subscription.
            </p> */}
            <Link to='/courses/' className='subscrice-banner-cta'>
              Start your free trial
            </Link>
          </section>
          {/* } */}
        </div>
      </div>
    </div>
  );
};

export default SubscribeBanner;
